import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { BsCloudSlash } from "react-icons/bs";
import { useOnline } from "duck";

const OfflineMark: React.FC = () => {
  const online = useOnline();

  return online ? null : (
    <Flex align="center" columnGap={3}>
      <BsCloudSlash color="#FC1F1F" size="26px" />
      <Text fontSize="sm" fontWeight="medium" color="#FC1F1F">
        Offline
      </Text>
    </Flex>
  );
};

export default OfflineMark;
